import { Metadata } from '../../../../utils/spds/metadata';
import Badge from './base.gjs';
import Super from '../../core/base.gjs';
import styles from './new.module.scss';

const METADATA = Metadata.define({
  description: 'New badge indicator used to highlight new features or content.',
  name: 'New Badge',
});

export default class SpdsIndicatorBadgeNew extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-indicator-badge-new';
  styles = styles;

  <template>
    <Badge class={{this.classes}} data-test-spds-indicator-badge-new ...attributes>
      New
    </Badge>
  </template>
}

export const BADGE_NEW_METADATA = SpdsIndicatorBadgeNew.metadata;
